import { useNavigate } from "react-router-dom";
import { collection, Timestamp, serverTimestamp } from "firebase/firestore";
import { createLocalDoc } from "../utils/offlineWrites";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { TripForm } from "../components/trips/TripForm";
import { usePageBar } from "../contexts/PageBarContext";

export function TripCreate() {
  const { user, userProfile } = useAuth();
  const navigate = useNavigate();
  usePageBar({ title: "New trip", cancel: { onClick: () => navigate("/trips") } });

  // Layout gates unauthenticated users with the sign-in screen, so user
  // is always set here. This guard only narrows the type for TS.
  if (!user) return null;

  // Seed the form with the organizer already in the travel party
  const initialTravelParty = {
    [user.uid]: {
      displayName: userProfile?.displayName || user.displayName || "Me",
      avatarUrl: userProfile?.avatarUrl || user.photoURL || null,
      userId: user.uid,
      connectionId: null,
      role: "organizer" as const,
      locationSharingEnabled: userProfile?.defaultLocationSharing ?? false,
      status: "confirmed" as const,
    },
  };

  const handleSubmit = async (data: {
    name: string;
    startDate: Date;
    endDate: Date;
    notes: string;
    travelParty?: Record<string, import("../types").TravelPartyMember>;
  }) => {
    const party = data.travelParty || initialTravelParty;
    const tripId = createLocalDoc(collection(db, "trips"), {
      name: data.name,
      startDate: Timestamp.fromDate(data.startDate),
      endDate: Timestamp.fromDate(data.endDate),
      notes: data.notes || null,
      createdBy: user.uid,
      memberUserIds: Object.values(party)
        .map((m) => m.userId)
        .filter((id): id is string => id != null),
      travelParty: party,
      people: [],
      createdAt: Timestamp.now(),
      updatedAt: serverTimestamp(),
    });

    navigate(`/trips/${tripId}`);
  };

  return (
    <div className="page">
      <h1>New Trip</h1>
      <TripForm
        initial={{ travelParty: initialTravelParty }}
        onSubmit={handleSubmit}
        onCancel={() => navigate("/trips")}
      />
    </div>
  );
}
